import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import { deliveryStore } from '@/stores/delivery'
import DeliveryDetailsRow from '@/components/delivery/DeliveryDetailsRow.vue'
import DeliveryContractorsRow from '@/components/delivery/DeliveryContractorsRow.vue'
import DeliveryEntityRow from '@/components/delivery/DeliveryEntityRow.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryDetailsCard',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Details",
    bordered: false
  }, {
    default: _withCtx(() => [
      (!_unref(deliveryStore)().delivery)
        ? (_openBlock(), _createBlock(_component_a_skeleton, {
            key: 0,
            active: ""
          }))
        : (_openBlock(), _createBlock(_component_a_row, {
            key: 1,
            class: "no-mb"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, {
                xs: {span: 24},
                sm: {span: 24},
                md: {span: 24},
                lg: {span: 12}
              }, {
                default: _withCtx(() => [
                  _createVNode(DeliveryDetailsRow, {
                    label: "Project",
                    content: _unref(deliveryStore)().delivery.building.project.name + ' (' + _unref(deliveryStore)().delivery.building.project.reference + ')'
                  }, null, 8, ["content"]),
                  (_unref(deliveryStore)().delivery.building)
                    ? (_openBlock(), _createBlock(DeliveryDetailsRow, {
                        key: 0,
                        label: "Bouwnummer",
                        content: _unref(deliveryStore)().delivery.building.number + ' (' + _unref(deliveryStore)().delivery.building.reference + ')'
                      }, null, 8, ["content"]))
                    : _createCommentVNode("", true),
                  (_unref(deliveryStore)().delivery.building.customer.contractors)
                    ? (_openBlock(), _createBlock(DeliveryContractorsRow, {
                        key: 1,
                        label: "De verkrijgers",
                        contractors: _unref(deliveryStore)().delivery.building.customer.contractors
                      }, null, 8, ["contractors"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_a_col, {
                xs: {span: 24},
                sm: {span: 24},
                md: {span: 24},
                lg: {span: 12}
              }, {
                default: _withCtx(() => [
                  (_unref(deliveryStore)().delivery.building.project.entity)
                    ? (_openBlock(), _createBlock(DeliveryEntityRow, {
                        key: 0,
                        label: "De ondernemer",
                        entity: _unref(deliveryStore)().delivery.building.project.entity
                      }, null, 8, ["entity"]))
                    : _createCommentVNode("", true),
                  (_unref(deliveryStore)().delivery.building)
                    ? (_openBlock(), _createBlock(DeliveryDetailsRow, {
                        key: 1,
                        label: _unref(deliveryStore)().delivery.type === 'inspection' ? 'Uit te voeren door' : 'Opleverfuctionaris',
                        content: _unref(deliveryStore)().delivery.type === 'inspection' ? _unref(deliveryStore)().delivery.inspection_scheduled_user.full_name : _unref(deliveryStore)().delivery.delivery_scheduled_user.full_name
                      }, null, 8, ["label", "content"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }))
}
}

})